// DISCO-602_v1 functionality
const LEAD_EMAIL_KEY = 'lead_email'
export const getLeadEmail = () => window?.localStorage.getItem(LEAD_EMAIL_KEY)
